import { Serializer, SurveyModel, SvgRegistry } from "survey-core";
import { plateSvg } from "./icons/plate";
import { selectorSvg } from "./icons/selector";
import { checkboxLargeSvg } from "./icons/checkboxLarge";
import { radioLargeSvg } from "./icons/radioLarge";
import {
  AppointmentTimeSlotQuestionModel,
  DamageFromDirectionQuestionModel,
  DecisionTableQuestionModel,
  DatePickerQuestionModel,
  LicensePlateQuestionModel,
  PhoneNumberQuestionModel,
  SelectorQuestionModel,
  CheckboxGroupLargeQuestionModel,
  RadioLargeQuestionModel,
  RadioCardQuestionModel,
  FileUploadQuestionModel,
  SignatureQuestionModel,
  TimePickerQuestionModel,
  RepairAllowedModel,
  FeatureListQuestionModel,
  DocumentExampleQuestionModel,
} from "../questions";
import { calendarSvg } from "./icons/calendar";
import { ViewQuestionModel } from "../questions/ViewQuestion";

export const registerSerializerExtensions = () => {
  /* Models */
  Serializer.addClass(
    "appointment-time-slot",
    [],
    () => new AppointmentTimeSlotQuestionModel(""),
    "question",
  );
  Serializer.addProperty("appointment-time-slot", {
    name: "servicePartner:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "dealership:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "company:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "dossierType:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "glassDamageLocation:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "glassDamageType:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "numberOfDamagePoints:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "jobType:expression",
    category: "logic",
  });
  Serializer.addProperty("appointment-time-slot", {
    name: "hasTimeSlots:boolean",
    category: "logic",
  });

  Serializer.addClass(
    "damage-from-direction",
    [
      { name: "imageStyle:text", category: "layout" },
      {
        name: "imageUrl:string",
        category: "data",
      },
      { name: "directionPaths:text" },
      { name: "choices", type: "itemvalues", category: "choices" },
    ],
    () => new DamageFromDirectionQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "datepicker",
    [],
    () => new DatePickerQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "decisionTable",
    [
      {
        name: "decisionTable",
        category: "data",
      },
    ],
    () => new DecisionTableQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "timepicker",
    [],
    () => new TimePickerQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "licensePlate",
    [
      {
        name: "fleetCheck:boolean",
      },
      {
        name: "evaluationGroupId:string",
      },
    ],
    () => new LicensePlateQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "repairAllowed",
    [
      {
        name: "evaluationGroupId:string",
      },
      {
        name: "optionalDefaultValue",
      },
    ],
    () => new RepairAllowedModel(""),
    "radiogroup",
  );

  Serializer.addClass(
    "selector",
    [],
    () => new SelectorQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "checkboxGroupLarge",
    [],
    () => new CheckboxGroupLargeQuestionModel(""),
    "checkbox",
  );

  Serializer.addClass(
    "radioLarge",
    [],
    () => new RadioLargeQuestionModel(""),
    "radiogroup",
  );

  Serializer.addClass(
    "radioCard",
    [],
    () => new RadioCardQuestionModel(""),
    "radiogroup",
  );

  Serializer.addClass(
    "fileupload",
    [],
    () => new FileUploadQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "signature",
    [],
    () => new SignatureQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "featurelist",
    [],
    () => new FeatureListQuestionModel(""),
    "question",
  );

  Serializer.addProperty("featurelist", {
    name: "heading",
    category: "general",
    type: "string",
    default: "Goed nieuws!",
  });

  Serializer.addProperty("featurelist", {
    name: "subtitle",
    category: "general",
    type: "string",
    default: "Schadeherstel in vertrouwde handen!",
  });

  Serializer.addProperty("featurelist", {
    name: "featuresHeading",
    category: "general",
    type: "string",
    default: "Bij MerkZeker ben je zeker van:",
  });

  Serializer.addProperty("featurelist", {
    name: "logoUrl",
    category: "general",
    type: "string",
    default:
      "https://cdn.rumbledirect.com/static/assets/merkzeker/merkzeker-white-bg.png",
  });

  Serializer.addClass(
    "phoneNumber",
    [],
    () => new PhoneNumberQuestionModel(""),
    "question",
  );

  Serializer.addClass(
    "documentExample",
    [
      {
        name: "imageUrl",
        category: "general",
        type: "string",
        isRequired: true,
      },
      {
        name: "downloadUrl",
        category: "general",
        type: "string",
        isRequired: true,
      },
      {
        name: "downloadLabel",
        category: "general",
        type: "string",
        isRequired: true,
      },
    ],
    () => new DocumentExampleQuestionModel(""),
    "question",
  );

  Serializer.addClass("view", [], () => new ViewQuestionModel(""), "question");

  /* Icons */
  SvgRegistry.registerIcon("appointment-time-slot", calendarSvg);
  SvgRegistry.registerIcon("damage-from-direction", selectorSvg);
  SvgRegistry.registerIcon("datepicker", calendarSvg);
  SvgRegistry.registerIcon("decisionTable", selectorSvg);
  SvgRegistry.registerIcon("timepicker", calendarSvg);
  SvgRegistry.registerIcon("licensePlate", plateSvg);
  SvgRegistry.registerIcon("selector", selectorSvg);
  SvgRegistry.registerIcon("checkboxGroupLarge", checkboxLargeSvg);
  SvgRegistry.registerIcon("radioLarge", radioLargeSvg);
  SvgRegistry.registerIcon("featurelist", checkboxLargeSvg);
  SvgRegistry.registerIcon("documentExample", checkboxLargeSvg);

  /* Properties */
  Serializer.addProperty("text", {
    name: "autoCapitalize",
    category: "general",
    type: "string",
    default: "none",
    choices: ["none", "sentences", "words", "characters"],
  });

  Serializer.addProperty("survey", {
    name: "layoutVariant",
    category: "layout",
    default: "standard",
    choices: [
      "standard",
      "withSidebar",
      "withTopBar",
      "twoColumn",
      "standardAdmin",
    ],
  });

  Serializer.addProperty("survey", {
    name: "completedPageAsStep:boolean",
    category: "layout",
    default: false,
  });

  Serializer.addProperty("page", {
    name: "nextButtonText:text",
    category: "navigation",
  });

  Serializer.addProperty("page", {
    name: "centerActions:boolean",
    category: "navigation",
    default: false,
  });

  Serializer.addProperty("page", {
    name: "copySelectorAddress:boolean",
    category: "general",
    default: false,
  });

  Serializer.addProperty("comment", {
    name: "showCount:boolean",
    category: "general",
    default: false,
  });

  Serializer.addProperty("comment", {
    name: "autoSize",
    category: "general",
  });

  Serializer.addProperty("fileupload", {
    name: "mimeTypes",
    category: "data",
    type: "string",
  });

  Serializer.addProperty("panel", {
    name: "hasSearchButton:boolean",
    category: "layout",
    default: false,
  });

  Serializer.addProperty("panel", {
    name: "searchTargetQuestionName:string",
    category: "layout",
    default: "selector",
  });

  Serializer.addProperty("question", {
    name: "payloadPath",
    category: "data",
  });

  Serializer.addProperty("question", {
    name: "subtitle:expression",
    category: "general",
  });

  Serializer.addProperty("question", {
    name: "allowTitleWrap:boolean",
    category: "layout",
    default: false,
  });

  Serializer.addProperty("selector", {
    name: "queryId:string",
    displayName: "RumbleDirect Selector Query ID",
    category: "data",
  });

  Serializer.addProperty("selector", {
    name: "glassDamageLocation:expression",
    category: "logic",
  });

  Serializer.addProperty("selector", {
    name: "servicePartnerCollection:expression",
    category: "logic",
  });

  Serializer.addProperty("selector", {
    name: "searchWithoutInput:boolean",
    category: "logic",
    default: false,
  });

  Serializer.addProperty("selector", {
    name: "visibleOptions:number",
    displayName: "Visible Options",
    category: "layout",
    default: 3,
  });

  Serializer.addProperty("selector", {
    name: "headerImageMaxHeight:number",
    displayName: "Header Image Max Height (px)",
    category: "layout",
    default: 100,
  });

  Serializer.addProperty("survey", {
    name: "submitResponse",
    category: "completion",
    visible: false,
  });

  Serializer.addProperty("survey", {
    name: "thankYouCardTitle:text",
    category: "completion",
    default: "Maak foto's van de schade & documenten",
  });

  Serializer.addProperty("survey", {
    name: "thankYouTitle:text",
    category: "completion",
    default: "Bedankt voor het maken van een afspraak!",
  });

  Serializer.addProperty("survey", {
    name: "thankYouBody:text",
    category: "completion",
    default:
      "Dank u wel voor het invullen voor deze digitale intake. We weten nu genoeg over uw schade en plannen deze voor u in. Om voor ons de schade beter in te kunnen schatten, hebben we nog een aantal foto’s nodig van de schade aan uw auto & de groen-witte kaart + kilometerstand. Zou u die voor ons willen maken? Dat zou ons helpen!",
  });

  // Note: SurveyJS may not reliably deserialize this custom array property.
  // Completed.tsx reads from survey.jsonObj as a fallback.
  Serializer.addProperty("survey", {
    name: "thankYouContent",
    category: "completion",
  });

  Serializer.addProperty("survey", {
    name: "showNewReportButton:boolean",
    category: "completion",
    default: false,
  });

  Serializer.addProperty("radiogroup", {
    name: "orientation",
    displayName: "Orientation",
    category: "layout",
    default: "vertical",
    choices: ["horizontal", "vertical"],
  });

  Serializer.addProperty("checkbox", {
    name: "orientation",
    displayName: "Orientation",
    category: "layout",
    default: "vertical",
    choices: ["horizontal", "vertical"],
  });

  Serializer.addProperty("itemvalue", {
    name: "textExtra",
    displayName: "Extra tekst",
    default: "",
    locationInTable: "detail",
  });

  Serializer.addProperty("itemvalue", {
    name: "icon",
    displayName: "Icon",
    default: "",
    locationInTable: "detail",
  });

  Serializer.addProperty("datepicker", {
    name: "showTime:boolean",
    displayName: "Show time",
    default: "",
    locationInTable: "layout",
  });

  Serializer.addProperty("survey", {
    name: "themeId:string",
    displayName: "Theme ID",
    default: "",
    locationInTable: "layout",
  });

  Serializer.addProperty("survey", {
    name: "footerText:text",
    category: "layout",
    default: "",
    serializationProperty: "locFooterText",
    onSetValue: (obj: SurveyModel, value: any) => {
      const locStr = obj.getLocalizableString("footerText");
      locStr.setJson(value);
      locStr.useMarkdown = true;
    },
  });
};
